/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { RefreshPlaylistsYoutubeMutationResponse, RefreshPlaylistsYoutubePathParams } from "../models/RefreshPlaylistsYoutube";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { refreshPlaylistsYoutube } from "../axios/refreshPlaylistsYoutube";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const refreshPlaylistsYoutubeMutationKey = () => ["social-export-api", { url: '/youtube/:station/playlists/refresh' }] as const

export type RefreshPlaylistsYoutubeMutationKey = ReturnType<typeof refreshPlaylistsYoutubeMutationKey>

export function refreshPlaylistsYoutubeMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = refreshPlaylistsYoutubeMutationKey()
        return mutationOptions<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, {station: RefreshPlaylistsYoutubePathParams["station"]}, TContext>({
          mutationKey,
          mutationFn: async({ station }) => {
            return refreshPlaylistsYoutube(station, config)
          },
        })

}

/**
 * @description Bypasses cache and fetches fresh playlists from YouTube API, then caches the result
 * @summary Refresh YouTube playlists for a station
 * {@link /youtube/:station/playlists/refresh}
 */
export function useRefreshPlaylistsYoutube<TContext>(options: 
{
  mutation?: UseMutationOptions<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, {station: RefreshPlaylistsYoutubePathParams["station"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? refreshPlaylistsYoutubeMutationKey()

          const baseOptions = refreshPlaylistsYoutubeMutationOptions(config) as UseMutationOptions<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, {station: RefreshPlaylistsYoutubePathParams["station"]}, TContext>
          

          return useMutation<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, {station: RefreshPlaylistsYoutubePathParams["station"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RefreshPlaylistsYoutubeMutationResponse, ResponseErrorConfig<Error>, {station: RefreshPlaylistsYoutubePathParams["station"]}, TContext>
      
}